import React, { useState } from 'react';
import '../../../assests/css/customer/ContactUs.css';
import Footer from '../../../components/Customer/Footer/Footer';
import MyNavbar from '../../../components/Customer/Mynavbar/MyNavbar';
import ContactForm from '../Home/ContactForm/ContactForm';

const ContactUs = () => {
  const [expandedFAQ, setExpandedFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setExpandedFAQ(expandedFAQ === index ? null : index);
  };

  const faqData = [
    {
      question: "How quickly can I expect a response?",
      answer: "We typically respond to all inquiries within 2 hours during business hours. For urgent matters, our 24/7 support team is available to assist you immediately."
    },
    {
      question: "What are your support hours?",
      answer: "Our support team is available 24/7 via email and chat. Phone support is available Monday through Friday, 9am-6pm EST."
    },
    {
      question: "Can I schedule a call with your team?",
      answer: "Absolutely! You can schedule a call through our contact form or by calling our main number. We'll arrange a time that works best for you."
    },
    {
      question: "Do you offer technical support?",
      answer: "Yes, our dedicated technical support team is available to help with any technical issues or questions you may have. We provide comprehensive assistance for all our services."
    },
    {
      question: "How can I provide feedback?",
      answer: "We love hearing from our customers! You can share feedback through our contact form, email us directly, or connect with us on social media. Your input helps us improve our services."
    }
  ];

  return (
    <>
      <MyNavbar />
      <div className="contact-page">
        {/* Section 1: Hero Section */}
        <section className="hero-section">
          <div className="hero-container">
            <div className="hero-content-wrapper">
              <h1 className="hero-main-title">
                Let's Start a <span className="gradient-text">Conversation</span>
              </h1>
              <p className="hero-description">
                Whether you have questions, feedback, or need support, our dedicated team is ready to assist you. Reach out and experience exceptional customer service.
              </p>
              <div className="hero-stats">
                <div className="stat-item">
                  <div className="stat-number">24/7</div>
                  <div className="stat-label">Support Available</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">&lt;2hrs</div>
                  <div className="stat-label">Response Time</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">98%</div>
                  <div className="stat-label">Satisfaction Rate</div>
                </div>
              </div>
            </div>

            <div className="hero-image-wrapper">
              <div className="hero-image-card">
                <img
                  src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&h=1000&fit=crop"
                  alt="Customer Support Team"
                />
                <div className="floating-badge badge-1">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                  <span>Verified Support</span>
                </div>
                <div className="floating-badge badge-2">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
                  </svg>
                  <span>Fast Response</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section 2: Contact Form — ab wahi ContactForm component use ho raha hai
            jo home page par bhi use ho raha hai, taky dono jagah same form ho */}
        <ContactForm />

        {/* Section 3: FAQ Section */}
        <section className="faq-section">
          <div className="faq-container">
            <div className="faq-left">
              <div className="faq-image">
                <img
                  src="https://images.unsplash.com/photo-1553484771-371a605b060b?w=800&h=1000&fit=crop"
                  alt="Customer Support"
                />
              </div>
            </div>

            <div className="faq-right">
              <div className="faq-title-wrapper">
                <h2 className="faq-title">Frequently Asked Questions</h2>
              </div>

              <div className="faq-list">
                {faqData.map((faq, index) => (
                  <div key={index} className="faq-item">
                    <button
                      className={`faq-question ${expandedFAQ === index ? 'active' : ''}`}
                      onClick={() => toggleFAQ(index)}
                    >
                      <span>{faq.question}</span>
                      <span className="faq-icon">{expandedFAQ === index ? '−' : '+'}</span>
                    </button>
                    {expandedFAQ === index && (
                      <div className="faq-answer">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default ContactUs;